import { ElectionOutcome } from '../models/TypeHelper'
import PartyResultMap from '../models/PartyResultMap'
import { IPartyOutcomeCountMap } from '../models/OutcomeController'

export const buildOutcomeCounts = (
  outcomes: PartyResultMap[]
): IPartyOutcomeCountMap => {
  const outcomeCounts: IPartyOutcomeCountMap = {}

  outcomes.forEach((outcome): void => {
    Object.values(outcome.results()).forEach((partyResult): void => {
      outcomeCounts[partyResult.party.code] =
        outcomeCounts[partyResult.party.code] || {}

      outcomeCounts[partyResult.party.code][partyResult.outcome] =
        outcomeCounts[partyResult.party.code][partyResult.outcome] + 1 || 1
    })
  })

  return outcomeCounts
}

export const filterByOutcome = (
  outcomes: PartyResultMap[],
  filters: ElectionOutcome[]
): IPartyOutcomeCountMap => {
  const outcomeCounts = buildOutcomeCounts(outcomes)

  Object.keys(outcomeCounts).filter((partyKey): boolean => {
    const count = outcomeCounts[partyKey]
    const matchesFilters = filters.some((filter: ElectionOutcome): boolean => {
      return count[filter] > 0
    })

    return matchesFilters
  })

  return outcomeCounts
}
